/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIv = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.001 2A3 3 0 0 1 15 5h-2a1 1 0 0 0-.999-1H6.999A1 1 0 0 0 6 5v17H4V5a3 3 0 0 1 2.999-3z" />
        <path
          clipRule="evenodd"
          d="M18 6a2 2 0 0 1 2 2v7.468a2 2 0 0 1-1.312 1.878L15 18.698V22h-2v-3.302l-3.688-1.352a2 2 0 0 1-1.306-1.722L8 15.468V8a2 2 0 0 1 2-2zm-8 6.988c1.048.41 3.103.984 4.67-.157 1.698-1.236 1.37-1.807 3.33-1.435V8h-8z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgIv as Iv };
